import React from 'react';

import { confirm } from './index';
import sceneActions from '../../../actions/sceneActions';

// eslint-disable-next-line default-param-last
export default function closeConfirmation({ message, callback, confirmProps = {}, t }) {
  const { text, headerText, okText, cancelText } = confirmProps;

  function onOk() {
    callback && callback(true);
  }

  function onCancel() {
    sceneActions.cancelDeleteScene();
    callback && callback(false);
  }

  confirm({
    onOk,
    onCancel,
    headerText: headerText || t('modals.closeEditor.headerText'),
    text: (
      <span
        dangerouslySetInnerHTML={{
          __html: text || t('modals.closeEditor.text'),
        }}
      />
    ),
    okText: okText !== undefined ? okText : t('modals.closeEditor.saveText'),
    cancelText: cancelText !== undefined ? cancelText : t('modals.closeEditor.cancelText'),
  });
}
